import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../';
import { StoredQuestion, Question } from '../../core-modules/model';
import {
  CookieManagerService,
  ErrorManagerService,
  HttpClientService,
} from '../';

@Injectable()
export class QnavigatorService {
  public storedQuestion: Subject<StoredQuestion[]> = new BehaviorSubject<StoredQuestion[]>(null);
  public compleatedQuestion: Subject<Number> = new BehaviorSubject<Number>(0);
  constructor() {

  }

  storeQuestion(Q: Question) {
    let storeQuection: StoredQuestion = new StoredQuestion();
    storeQuection.id = Q._id;
    storeQuection.questionNumber = Q.questionNumber;
    storeQuection.isSkiped = Q.isSkiped;
    storeQuection.isGroup = Q.isGroup;
    storeQuection.answerId = Q.selectedAnswerid;
    storeQuection.isNew = false;
    storeQuection.questionType = Q.questionType;
    storeQuection.isMain = Q.isMain;

    if(Q.questionType === "gr_type_12"){
      storeQuection.parentObjId = Q.parentObj.parentObj._id;
    }else{
      storeQuection.parentObjId = null;
    }
    
    if(Q.parentObj){
      if(Q.parentObj.parentObj || false){
        // storeQuection.questionLable = Q.parentObj.parentObj.questionNumber+ '-'+Q.parentObj.questionNumber+ '-'+ Q.questionLabel;
        storeQuection.questionLable = Q.parentObj.parentObj.questionNumberLabel+ '-'+Q.parentObj.questionNumberLabel+ '-'+ Q.questionNumberLabel;
        storeQuection.q = {
          "q" : Q.parentObj.parentObj.questionNumberLabel,
          "sq" : Q.parentObj.questionNumberLabel,
          "ssq" : Q.questionNumberLabel
        }
      }else{
        // storeQuection.questionLable = Q.parentObj.questionNumber+ '-'+ Q.questionNumber;
         storeQuection.questionLable = Q.questionLabel
      }
    }else{
      storeQuection.questionLable = Q.questionLabel
    }
    
     if (Q.isSkiped === undefined) {
      storeQuection.isNew = true;
    }
    storeQuection.done = !storeQuection.isNew && !Q.isSkiped;

    if (Q.answerIds && Q.correctAnswer.words.length != Q.answerIds.length) {
      storeQuection.done = false;
      storeQuection.isSkiped  = true;

    }
    localStorage.setItem('question-' + Q.questionNumber, JSON.stringify(storeQuection));
    let allItems = this.allStorage();
    let items: any = allItems;
    this.storedQuestion.next(items);
    let count = 0;
    
    let reduceItems = allItems.reduce( (groups, item) => {
      let val = item['parentObjId'];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
    // reduceItems.for((items, key) => {
    //   console.log(items, key);
      // if (items.done) {
      //   count++;
      // }
    // })
    for (let index in reduceItems) {
      if (!reduceItems.hasOwnProperty(index)) {
          continue;
      }
      if (index==="null") {
        reduceItems[index].forEach(item => {
          if (item.done) {
            count++;
          }
        });
      }else{
        let subQDoneCount = 0
        reduceItems[index].forEach(item => {
          if (item.done) {
            subQDoneCount++;
          }
        });
        if(subQDoneCount===reduceItems[index].length){
          count++;
        }
      }
    }
    this.compleatedQuestion.next(count);
  }

  allStorage() {
    var values = new Array<StoredQuestion>(),
      keys = Object.keys(localStorage),
      i = keys.length;

    keys.sort((a: any, b: any) => {
      return b.replace('question-', '') - a.replace('question-', '');
    });

    while (i--) {
      if (keys[i].includes('question-')) {
        values.push(new StoredQuestion(JSON.parse(localStorage.getItem(keys[i]))));
      }
    }
    return values;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/qnavigator.service.ts